export enum TIME_INTERVAL {
    TODAY = 'TODAY',
    YESTERDAY = 'YESTERDAY',
    THIS_WEEK = 'THIS_WEEK',
    LAST_WEEK = 'LAST_WEEK',
    THIS_MONTH = 'THIS_MONTH',
    LAST_MONTH = 'LAST_MONTH',
    CUSTOM = 'CUSTOM',
}

export enum TIME_UNIT {
    MINUTES = 'minutes',
    HOUR = 'hour',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
}

export enum DATE_FORMAT {
    LONG_FULL_DATE,
    LONG_FULL_DATE_TIME,
    SHORT_FULL_DATE,
    SHORT_FULL_DATE_TIME,
    LONG_DATE,
    LONG_DATE_TIME,
    SHORT_DATE,
    SHORT_DATE_TIME,
    TIME,
}
